import { faArrowRight, faBars, faHouse, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
const posterSrc = 'https://dt7j04u1665qi.cloudfront.net/LandingBackground.webp'
const logo = 'https://dt7j04u1665qi.cloudfront.net/all_brands_logos_170-40.webp'

const LandingPage = () => {
  const videoSrc1 = "https://ggfx-allegiance.s3.eu-west-2.amazonaws.com/i.prod/Main_Video_Crop_1_4_2_Mb_2ae1abc7a0.mp4"
  const videoSrc2 = "https://ggfx-allegiance.s3.eu-west-2.amazonaws.com/i.prod/Home_page_1_a6bc0ce7a5.mp4"
  const [showMenu, setShowMenu] = useState(false);
  const [showLogo, setShowLogo] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust the threshold based on your mobile design needs
    };

    checkIsMobile(); // Initial check

    // Update isMobile on window resize
    window.addEventListener('resize', checkIsMobile);

    return () => {
      // Remove event listener on component unmount
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const videoSrc = isMobile ? videoSrc2 : videoSrc1;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleVideoLoad = () => {
    setVideoLoaded(true);
  };

  useEffect(() => {
    // Simulate delay for logo animation (You can adjust the delay value)
    const logoAnimationDelay = setTimeout(() => {
      setShowLogo(true);
    }, 500);

    // Clean up the timeout to prevent memory leaks
    return () => clearTimeout(logoAnimationDelay);
  }, []);

  const closeMenu = () => {
    setShowMenu(false);
  };

  return (
    <header id="home" className="tracking-widest relative min-h-screen flex flex-col justify-between overflow-hidden">
      {videoLoaded ? null : (
        <div className="w-full h-full object-cover absolute inset-0 z-0">
          <img
            src={posterSrc}
            className="w-full h-full object-cover"
            alt="Video Poster"
          />
        </div>
      )}
      <video
        autoPlay
        loop
        muted
        playsInline
        className={`w-full h-full object-cover absolute inset-0 z-0 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`}
        src={videoSrc}
        onLoadedData={handleVideoLoad}
      ></video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/55 z-0" />

      {/* Top Header Section */}
      <div className="relative z-10 w-full p-4 sm:p-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center">
            {showLogo && (
              <div className="w-36 sm:w-48 md:w-56 text-white animate-slideInLeft">
                <img
                  src={logo}
                  className="w-full h-auto object-contain"
                  alt="Haideries Logo"
                />
              </div>
            )}
          </div>

          {/* Mobile Hamburger Button */}
          <div className="md:hidden">
            <button
              aria-label="Toggle navigation menu"
              onClick={toggleMenu}
              className="text-white p-2 rounded-md hover:bg-white/10 text-xl"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden font-light md:flex items-center space-x-6 text-sm">
            <Link to="/connect" className="btn-header text-white hover:text-gray-300 flex items-center">
              <FontAwesomeIcon icon={faSearch} className='mr-2' /> PROPERTY SEARCH
            </Link>
            <div className="h-4 border-r border-white/60"></div>
            <Link to="/ListProperty" className="btn-header text-white hover:text-gray-300 flex items-center">
              <FontAwesomeIcon icon={faHouse} className='mr-2' /> LIST YOUR PROPERTY
            </Link>
            <div className="h-4 border-r border-white/60"></div>
            <button
              onClick={toggleMenu}
              className="btn-header text-white hover:text-gray-300 flex items-center cursor-pointer"
            >
              <FontAwesomeIcon icon={faBars} className='mr-2' /> MENU
            </button>
          </nav>
        </div>
      </div>

      {/* Mobile Backdrop */}
      {showMenu && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-xs z-50 transition-opacity duration-300"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}

      {/* Mobile & Desktop Drawer Menu */}
      <div
        className={`fixed top-0 right-0 bottom-0 w-4/5 max-w-sm sm:max-w-md bg-colourBg z-50 shadow-2xl p-6 sm:p-8 overflow-y-auto transform transition-transform duration-300 ease-in-out ${
          showMenu ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between pb-6 border-b border-gray-700">
          <span className="text-xl font-bold tracking-widest text-white">HAIDERIES</span>
          <button
            onClick={closeMenu}
            aria-label="Close menu"
            className="p-2 text-gray-400 hover:text-white rounded-md hover:bg-white/10"
          >
            ✕
          </button>
        </div>

        <div className="text-xs text-gray-300 py-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {/* BUY PROPERTY */}
          <div>
            <h2 className="text-sm text-white font-semibold mb-3">BUY PROPERTY</h2>
            <ul className="space-y-2">
              <li><Link to="/ComingSoon" onClick={closeMenu} className="hover:text-white transition-colors">Properties for sale</Link></li>
              <li><Link to="/BuyWithHaideries" onClick={closeMenu} className="hover:text-white transition-colors">Buying with Haideries</Link></li>
              <li><Link to="/BuyersGuide" onClick={closeMenu} className="hover:text-white transition-colors">Buyers Guide</Link></li>
            </ul>
          </div>

          {/* SELL PROPERTY */}
          <div>
            <h2 className="text-sm text-white font-semibold mb-3">SELL PROPERTY</h2>
            <ul className="space-y-2">
              <li><Link to="/BookValuation" onClick={closeMenu} className="hover:text-white transition-colors">Book a valuation</Link></li>
              <li><Link to="/ListProperty" onClick={closeMenu} className="hover:text-white transition-colors">List your Property</Link></li>
              <li><Link to="/SellYourProperty" onClick={closeMenu} className="hover:text-white transition-colors">Sell with Haideries</Link></li>
              <li><Link to="/SellersGuide" onClick={closeMenu} className="hover:text-white transition-colors">Seller Guide</Link></li>
            </ul>
          </div>

          {/* RENT PROPERTY */}
          <div>
            <h2 className="text-sm text-white font-semibold mb-3">RENT PROPERTY</h2>
            <ul className="space-y-2">
              <li><Link to="/ComingSoon" onClick={closeMenu} className="hover:text-white transition-colors">Properties for rent</Link></li>
              <li><Link to="/RentWithHaideries" onClick={closeMenu} className="hover:text-white transition-colors">Why rent with Haideries</Link></li>
              <li><Link to="/TenantsGuide" onClick={closeMenu} className="hover:text-white transition-colors">Tenants Guide</Link></li>
            </ul>
          </div>

          {/* ABOUT & ROADSHOWS */}
          <div>
            <h2 className="text-sm text-white font-semibold mb-3">EXPLORE</h2>
            <ul className="space-y-2">
              <li><Link to="/RoadShows" onClick={closeMenu} className="hover:text-white transition-colors">International Roadshows</Link></li>
              <li><Link to="/WhyHaideries" onClick={closeMenu} className="hover:text-white transition-colors">Why Haideries</Link></li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="sm:col-span-2">
            <h2 className="text-sm text-white font-semibold mb-3">CONTACT & LEGAL</h2>
            <ul className="space-y-2">
              <li><Link to="/Contact" onClick={closeMenu} className="hover:text-white transition-colors">General Enquiry</Link></li>
              <li><Link to="/TermsAndConditions" onClick={closeMenu} className="hover:text-white transition-colors">Terms and Conditions</Link></li>
              <li><Link to="/PrivacyPolicy" onClick={closeMenu} className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/CookiePolicy" onClick={closeMenu} className="hover:text-white transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-4 border-t border-gray-700">
          <button
            onClick={closeMenu}
            className="w-full py-3 bg-white text-black font-semibold rounded-md hover:bg-gray-200 transition-colors"
          >
            CLOSE
          </button>
        </div>
      </div>

      {/* Main Hero Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-center px-4 sm:px-6 md:px-8 py-8 sm:py-12">
        <div className="max-w-5xl mx-auto w-full text-center mb-6 sm:mb-10">
          <h1 className="tracking-widest text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-thin animate-slideInLeft mb-2">
            GLOBALLY CONNECTED
          </h1>
          <h1 className="tracking-widest text-2xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-thin animate-slideInRight">
            LOCALLY ROOTED...
          </h1>
        </div>

        {/* Search Card */}
        <div className="w-full max-w-2xl mx-auto bg-white/15 backdrop-blur-md rounded-lg p-5 sm:p-8 text-white shadow-xl">
          <div className="flex justify-center space-x-6 sm:space-x-10 mb-4 sm:mb-6 text-xs sm:text-sm tracking-widest font-medium">
            <span className="cursor-pointer pb-1 border-b-2 border-white">BUY</span>
            <span className="cursor-pointer pb-1 border-b-2 border-transparent hover:border-white/50 transition-colors">RENT</span>
            <span className="cursor-pointer pb-1 border-b-2 border-transparent hover:border-white/50 transition-colors">OFFPLAN</span>
          </div>

          <form
            onSubmit={(e) => { e.preventDefault(); }}
            className="flex flex-col sm:flex-row gap-2 sm:gap-0"
          >
            <input
              type="text"
              placeholder="City, Community or Area"
              className="w-full bg-white rounded-md sm:rounded-none sm:rounded-l-md py-3 px-4 text-xs sm:text-sm text-black placeholder-gray-500 focus:outline-none"
            />
            <button
              type="submit"
              className="w-full sm:w-auto bg-black hover:bg-gray-900 text-white font-semibold py-3 px-6 rounded-md sm:rounded-none sm:rounded-r-md text-xs sm:text-sm tracking-wider transition-colors"
            >
              SEARCH
            </button>
          </form>
        </div>
      </div>

      {/* Bottom CTA */}
      <div className="relative z-10 pb-6 sm:pb-8 px-4 text-center">
        <p className="text-white text-xs sm:text-sm flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2">
          <span>Do you need to Sell or Rent your Property?</span>
          <Link to="/ListProperty" className="inline-flex items-center font-bold underline hover:text-gray-200">
            List Your Property
            <FontAwesomeIcon className="ml-1 text-xs" icon={faArrowRight} style={{ transform: "rotate(-30deg)" }} />
          </Link>
        </p>
      </div>
    </header>
  );
};

export default LandingPage;
